import tippy from 'tippy.js';
import './style.sass';
import 'tippy.js/dist/tippy.css';

function initTippyTooltip() {
    const $self = $(this);
    const content = $self.data('tippy-tooltip-content');
    let arrow = $self.data('tippy-tooltip-arrow');
    let delay = $self.data('tippy-tooltip-delay');
    let theme = $self.data('tippy-tooltip-theme');
    let offsetX = $self.data('tippy-tooltip-offset-x');
    let offsetY = $self.data('tippy-tooltip-offset-y');
    let appendTo = $self.data('tippy-tooltip-append-to');
    let maxWidth = $self.data('tippy-tooltip-max-width');
    let placement = $self.data('tippy-tooltip-placement');
    let isJson = $self.data('tippy-tooltip-content-json');
    let interactive = $self.data('tippy-tooltip-interactive');
    let interactiveBorder = $self.data('tippy-tooltip-interactive-border');

    arrow = typeof arrow !== 'undefined' ? arrow : true;
    delay = typeof delay !== 'undefined' ? delay : [300, 100];
    theme = typeof theme !== 'undefined' && !!theme ? theme : 'light';
    isJson = typeof isJson !== 'undefined' ? isJson : false;
    offsetX = typeof offsetX !== 'undefined' ? offsetX : 0;
    offsetY = typeof offsetY !== 'undefined' ? offsetY : 5;
    maxWidth = typeof maxWidth !== 'undefined' ? maxWidth : 340;
    appendTo = typeof appendTo !== 'undefined' && !!appendTo ? $(appendTo)[0] : this;
    placement = typeof placement !== 'undefined' && !!placement ? placement : 'top';
    interactive = typeof interactive !== 'undefined' ? interactive : true;
    interactiveBorder = typeof interactiveBorder !== 'undefined' ? interactiveBorder : 10;

    if (typeof content !== 'undefined' && !!content) {
        tippy(this, {
            allowHTML: true,
            hideOnClick: 'toggle',
            arrow: arrow,
            theme: theme,
            delay: delay,
            appendTo: appendTo,
            maxWidth: maxWidth,
            placement: placement,
            interactive: interactive,
            offset: offsetX + ', ' + offsetY,
            interactiveBorder: interactiveBorder,
            content: isJson ? JSON.parse(content) : content,
        });
    }
}

export { initTippyTooltip };



// WEBPACK FOOTER //
// ./js/main/module/tippy/module.js